import { collection, getDocs, limit, orderBy, query, startAfter, where } from "firebase/firestore";
import { db } from "../firebase";

const getStockItems = async (venueId) => {
  try {
    const stockItemsQuery = query(collection(db, "StockItems"), where("venueId", "==", venueId));
    const querySnapshot = await getDocs(stockItemsQuery);
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error while getting stock items:", error);
    throw error;
  }
};

const getStockCategories = async (venueId) => {
  try {
    const stockItemsQuery = query(
      collection(db, "StockCategories"),
      where("venueId", "==", venueId),
    );
    const querySnapshot = await getDocs(stockItemsQuery);
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error while getting stock categories:", error);
    throw error;
  }
};

const getStockMovements = async (venueId, stockItemId = null, after = null, before = null) => {
  try {
    const queryConditions = [where("venueId", "==", venueId)];
    if (stockItemId) queryConditions.push(where("stockItemId", "==", stockItemId));
    if (after) queryConditions.push(where("createdAt", ">=", after));
    if (before) queryConditions.push(where("createdAt", "<=", before));

    const stockItemsQuery = query(collection(db, "StockMovements"), ...queryConditions);
    const querySnapshot = await getDocs(stockItemsQuery);
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error while getting stock movements:", error);
    throw error;
  }
};

const getStockMovementsPage = async ({
  venueId,
  stockItemId,
  pageSize = 50,
  cursor = null,
}) => {
  try {
    const queryConditions = [
      where("venueId", "==", venueId),
      where("stockItemId", "==", stockItemId),
      orderBy("createdAt", "desc"),
      limit(pageSize),
    ];

    if (cursor) queryConditions.push(startAfter(cursor));

    const movementsQuery = query(collection(db, "StockMovements"), ...queryConditions);
    const querySnapshot = await getDocs(movementsQuery);

    return {
      movements: querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] || null,
      hasMore: querySnapshot.docs.length === pageSize,
    };
  } catch (error) {
    console.error("Error while getting paginated stock movements:", error);
    throw error;
  }
};

const getStockLossStats = async (venueId) => {
  try {
    const statsQuery = query(collection(db, "StockLossStats"), where("venueId", "==", venueId));
    const querySnapshot = await getDocs(statsQuery);
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error while getting stock loss stats:", error);
    throw error;
  }
};

export {
  getStockItems,
  getStockCategories,
  getStockMovements,
  getStockMovementsPage,
  getStockLossStats,
};
